// import React, { FC } from "react";

// export interface CheckboxProps {
//   label?: React.ReactNode;
//   subLabel?: string;
//   className?: string;
//   sizeClassName?: string;
//   labelClassName?: string;
//   name: string;
//   checked?: boolean;
//   onChange?: (checked: boolean) => void;
// }

// const Checkbox: FC<CheckboxProps> = ({
//   subLabel = "",
//   label = "",
//   name,
//   className = "",
//   sizeClassName = "w-5 h-5",
//   labelClassName = "",
//   checked = false,
//   onChange,
// }) => {
//   return (
//     <label
//       htmlFor={name}
//       className={`flex items-start space-x-3 cursor-pointer select-none ${className}`}
//     >
//       <input
//         id={name}
//         name={name}
//         type="checkbox"
//         checked={checked}
//         onChange={(e) => onChange?.(e.target.checked)}
//         className={`shrink-0 rounded border-slate-400 text-indigo-600 focus:ring-indigo-500 ${sizeClassName} cursor-pointer`}
//       />

//       <div className="flex flex-col">
//         {label && (
//           <span
//             className={`text-sm text-indigo-900 dark:text-white ${labelClassName}`}
//           >
//             {label}
//           </span>
//         )}
//         {subLabel && (
//           <span className="text-xs text-indigo-500 dark:text-slate-400 mt-0.5">
//             {subLabel}
//           </span>
//         )}
//       </div>
//     </label>
//   );
// };

// export default Checkbox;

import { ICheckboxProps } from "Interfaces/interface.uiUtils";
import React, { FC } from "react";

const Checkbox: FC<ICheckboxProps> = ({
  subLabel = "",
  label = "",
  name,
  className = "",
  sizeClassName = "w-5 h-5",
  labelClassName = "",
  checked = false,
  onChange,
  disabled,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    onChange?.(e.target.checked);
  };

  const handleLabelClick = (e: React.MouseEvent) => {
    if (disabled) return;
    e.preventDefault();
    e.stopPropagation();

    onChange?.(!checked);
  };

  const labelTextClass = disabled
    ? "text-gray-500 dark:text-gray-400"
    : "text-indigo-800 dark:text-white";

  const cursorClass = disabled ? "cursor-not-allowed" : "cursor-pointer";

  return (
    <div
      className={`flex items-start space-x-3 select-none ${className} ${cursorClass}`}
    >
      <input
        id={name}
        name={name}
        disabled={disabled}
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        className={`shrink-0 rounded border-slate-400 text-indigo-600 focus:ring-indigo-500 ${sizeClassName} ${cursorClass}`}
      />

      <div className="flex flex-col" onClick={handleLabelClick}>
        {label && (
          <span className={`text-sm ${labelTextClass} ${labelClassName}`}>
            {label}
          </span>
        )}
        {subLabel && (
          <span
            className={`text-xs ${labelTextClass} dark:text-gray-400 mt-0.5 ${cursorClass}`}
          >
            {subLabel}
          </span>
        )}
      </div>
    </div>
  );
};

export default Checkbox;
